import { PlusCircle } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const PlusCircleIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <PlusCircle width={size} height={size} color={color} {...rest} />;

PlusCircleIcon.displayName = 'PlusCircleIcon';

export default PlusCircleIcon;
